<template>
  <div class="home-contact-page">
    <!-- Intro Section -->
    <section class="contact-intro position-relative see__pad">
      <div class="pattern-layer">
        <div class="pattern-1 position-absolute" style="background-image: url('/shapes/shape-07.png')"></div>
      </div>
      <div class="pattern-layer">
        <div class="pattern-2 position-absolute" style="background-image: url('/shapes/shape-08.png')"></div>
      </div>
      <div class="pattern-layer">
        <div class="pattern-3 position-absolute" style="background-image: url('/shapes/shape-09.png')"></div>
      </div>
      <div class="pattern-layer">
        <div class="pattern-4 position-absolute" style="background-image: url('/shapes/shape-10.png')"></div>
      </div>
      
      <div class="header-container">
        <div class="row">
          <div class="col-lg-12">
            <div class="contact-intro-content text-center">
              <div class="contact-section-label">
                <h4>Get In Touch</h4>
              </div>
              <div class="contact-main-title">
                <h2>Contact Us</h2>
              </div>
              <div class="contact-description">
                <p>Ready to start your next project? We'd love to hear from you. Send us a message and we'll respond as soon as possible.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Contact Form & Info Section -->
    <section class="contact-form-info position-relative see__pad">
      <div class="pattern-layer">
        <div class="pattern-5 position-absolute" style="background-image: url('/shapes/shape-07.png')"></div>
      </div>
      <div class="pattern-layer">
        <div class="pattern-6 position-absolute" style="background-image: url('/shapes/shape-08.png')"></div>
      </div>
      <div class="pattern-layer">
        <div class="pattern-7 position-absolute" style="background-image: url('/shapes/shape-09.png')"></div>
      </div>
      <div class="pattern-layer">
        <div class="pattern-8 position-absolute" style="background-image: url('/shapes/shape-10.png')"></div>
      </div>
      
      <div class="container">
        <div class="row">
          <!-- Contact Form -->
          <div class="col-lg-8">
            <div class="contact-form-wrapper">
              <div class="contact-form-header">
                <h3>Send us a Message</h3>
                <p>Fill out the form below and we'll get back to you within 24 hours.</p>
              </div>
              
              <form class="contact-form" @submit.prevent="submitForm">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="firstName">First Name *</label>
                      <input 
                        type="text" 
                        id="firstName" 
                        v-model="form.firstName" 
                        required 
                        class="form-control"
                      >
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="lastName">Last Name *</label>
                      <input 
                        type="text" 
                        id="lastName" 
                        v-model="form.lastName" 
                        required 
                        class="form-control"
                      >
                    </div>
                  </div>
                </div>
                
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="email">Email Address *</label>
                      <input 
                        type="email" 
                        id="email" 
                        v-model="form.email" 
                        required 
                        class="form-control"
                      >
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="phone">Phone Number</label>
                      <input 
                        type="tel" 
                        id="phone" 
                        v-model="form.phone" 
                        class="form-control"
                      >
                    </div>
                  </div>
                </div>
                
                <div class="form-group">
                  <label for="company">Company/Organization</label>
                  <input 
                    type="text" 
                    id="company" 
                    v-model="form.company" 
                    class="form-control"
                  >
                </div>
                
                <div class="form-group">
                  <label for="subject">Subject *</label>
                  <select id="subject" v-model="form.subject" required class="form-control">
                    <option value="">Select a subject</option>
                    <option value="general">General Inquiry</option>
                    <option value="services">Services</option>
                    <option value="partnership">Partnership</option>
                    <option value="careers">Careers</option>
                    <option value="support">Support</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                
                <div class="form-group">
                  <label for="message">Message *</label>
                  <textarea 
                    id="message" 
                    v-model="form.message" 
                    required 
                    rows="6" 
                    class="form-control"
                    placeholder="Tell us about your project or inquiry..."
                  ></textarea>
                </div>
                
                <div class="form-group">
                  <button type="submit" class="theme-btn theme-btn-one" :disabled="isSubmitting">
                    <i class="icon-02"></i> 
                    {{ isSubmitting ? 'Sending...' : 'Send Message' }}
                  </button>
                </div>
              </form>
            </div>
          </div>
          
          <!-- Contact Information -->
          <div class="col-lg-4">
            <div class="contact-info-wrapper">
              <div class="contact-info-header">
                <h3>Get in Touch</h3>
                <p>We're here to help and answer any question you might have.</p>
              </div>
              
              <div class="contact-info-items">
                <div class="contact-info-item">
                  <div class="info-icon">
                    <i class="fas fa-map-marker-alt"></i>
                  </div>
                  <div class="info-content">
                    <h4>Address</h4>
                    <p>123 Innovation Street<br>Tech City, TC 12345<br>United States</p>
                  </div>
                </div>
                
                <div class="contact-info-item">
                  <div class="info-icon">
                    <i class="fas fa-phone"></i>
                  </div>
                  <div class="info-content">
                    <h4>Phone</h4>
                    <p>+1 (555) 123-4567<br>+1 (555) 987-6543</p>
                  </div>
                </div>
                
                <div class="contact-info-item">
                  <div class="info-icon">
                    <i class="fas fa-envelope"></i>
                  </div>
                  <div class="info-content">
                    <h4>Email</h4>
                    <p>info@sogdo.com<br>support@sogdo.com</p>
                  </div>
                </div>
                
                <div class="contact-info-item">
                  <div class="info-icon">
                    <i class="fas fa-clock"></i>
                  </div>
                  <div class="info-content">
                    <h4>Business Hours</h4>
                    <p>Monday - Friday: 9:00 AM - 6:00 PM<br>Saturday: 10:00 AM - 4:00 PM<br>Sunday: Closed</p>
                  </div>
                </div>
              </div>
              
              <div class="social-links">
                <h4>Follow Us</h4>
                <div class="social-icons">
                  <a href="#" class="social-icon"><i class="fab fa-facebook-f"></i></a>
                  <a href="#" class="social-icon"><i class="fab fa-twitter"></i></a>
                  <a href="#" class="social-icon"><i class="fab fa-linkedin-in"></i></a>
                  <a href="#" class="social-icon"><i class="fab fa-instagram"></i></a>
                  <a href="#" class="social-icon"><i class="fab fa-youtube"></i></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Map Section -->
    <section class="contact-map position-relative">
      <div class="map-container">
        <iframe 
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3022.9663095343008!2d-74.00425878459418!3d40.74844097932681!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c259a9b3117469%3A0xd134e199a405a163!2sEmpire%20State%20Building!5e0!3m2!1sen!2sus!4v1635959123456!5m2!1sen!2sus" 
          width="100%" 
          height="400" 
          style="border:0;" 
          allowfullscreen="" 
          loading="lazy"
        ></iframe>
      </div>
    </section>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { WOW } from 'wowjs'

export default {
  name: 'HomeContactUsPage',
  setup() {
    const form = ref({
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      company: '',
      subject: '',
      message: ''
    })
    
    const isSubmitting = ref(false)

    const submitForm = async () => {
      isSubmitting.value = true
      
      try {
        // Simulate form submission
        await new Promise(resolve => setTimeout(resolve, 2000))
        
        // Reset form
        form.value = {
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          company: '',
          subject: '',
          message: ''
        }
        
        alert('Thank you for your message! We\'ll get back to you soon.')
      } catch (error) {
        console.error('Form submission error:', error)
        alert('Sorry, there was an error sending your message. Please try again.')
      } finally {
        isSubmitting.value = false
      }
    }

    onMounted(() => {
      // Initialize WOW.js
      new WOW({
        mobile: false,
        live: false
      }).init()
    })

    return {
      form,
      isSubmitting,
      submitForm
    }
  }
}
</script>

<style scoped>
/* Import Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');

/* Import Flaticon */
@import '@/assets/scss/Flaticon.scss';

/* Home Contact Page Styles */
.home-contact-page {
  background: #f8f9fa;
}

/* Intro Section */
.contact-intro {
  padding: 100px 0 60px;
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  position: relative;
  overflow: hidden;
}

.contact-intro .pattern-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.contact-intro .pattern-1 {
  top: 10%;
  left: 5%;
  width: 100px;
  height: 100px;
  opacity: 0.1;
}

.contact-intro .pattern-2 {
  top: 20%;
  right: 10%;
  width: 80px;
  height: 80px;
  opacity: 0.1;
}

.contact-intro .pattern-3 {
  bottom: 20%;
  left: 15%;
  width: 120px;
  height: 120px;
  opacity: 0.1;
}

.contact-intro .pattern-4 {
  bottom: 10%;
  right: 5%;
  width: 90px;
  height: 90px;
  opacity: 0.1;
}

.contact-section-label h4 {
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 3px;
  color: #F6EC4F;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
  text-transform: uppercase;
}

.contact-main-title h2 {
  font-size: 48px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
}

.contact-description p {
  font-size: 18px;
  color: #ccc;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

/* Contact Form & Info Section */
.contact-form-info {
  padding: 80px 0;
  background: #fff;
  position: relative;
  overflow: hidden;
}

.contact-form-info .pattern-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.contact-form-info .pattern-5 {
  top: 15%;
  left: 3%;
  width: 60px;
  height: 60px;
  opacity: 0.05;
}

.contact-form-info .pattern-6 {
  top: 25%;
  right: 8%;
  width: 70px;
  height: 70px;
  opacity: 0.05;
}

.contact-form-info .pattern-7 {
  bottom: 25%;
  left: 10%;
  width: 80px;
  height: 80px;
  opacity: 0.05;
}

.contact-form-info .pattern-8 {
  bottom: 15%;
  right: 3%;
  width: 50px;
  height: 50px;
  opacity: 0.05;
}

.contact-form-wrapper {
  background: #fff;
  padding: 40px;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
}

.contact-form-header h3 {
  font-size: 28px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 10px;
  font-family: 'Archivo', sans-serif;
}

.contact-form-header p {
  font-size: 16px;
  color: #6c757d;
  margin-bottom: 30px;
}

.form-group {
  margin-bottom: 25px;
}

.form-group label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
  font-family: 'Archivo', sans-serif;
}

.form-control {
  width: 100%;
  padding: 12px 15px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 16px;
  transition: all 0.3s ease;
  background: #fff;
}

.form-control:focus {
  outline: none;
  border-color: #dc3545;
  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);
}

.form-control::placeholder {
  color: #adb5bd;
}

textarea.form-control {
  resize: vertical;
  min-height: 120px;
}

.theme-btn {
  background: linear-gradient(135deg, #dc3545, #c82333);
  color: white;
  border: none;
  padding: 15px 35px;
  border-radius: 30px;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.theme-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 25px rgba(220, 53, 69, 0.3);
}

.theme-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

/* Contact Info */
.contact-info-wrapper {
  background: #f8f9fa;
  padding: 40px;
  border-radius: 20px;
  height: fit-content;
  position: sticky;
  top: 100px;
}

.contact-info-header h3 {
  font-size: 24px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 10px;
  font-family: 'Archivo', sans-serif;
}

.contact-info-header p {
  font-size: 16px;
  color: #6c757d;
  margin-bottom: 30px;
}

.contact-info-item {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  margin-bottom: 30px;
  padding: 20px;
  background: white;
  border-radius: 15px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
}

.info-icon {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #dc3545, #c82333);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.info-icon i {
  font-size: 20px;
  color: white;
}

.info-content h4 {
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
  font-family: 'Archivo', sans-serif;
}

.info-content p {
  font-size: 14px;
  color: #6c757d;
  line-height: 1.6;
  margin: 0;
}

.social-links {
  margin-top: 30px;
  padding-top: 30px;
  border-top: 1px solid #e9ecef;
}

.social-links h4 {
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 15px;
  font-family: 'Archivo', sans-serif;
}

.social-icons {
  display: flex;
  gap: 10px;
}

.social-icon {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #dc3545, #c82333);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-decoration: none;
  transition: all 0.3s ease;
}

.social-icon:hover {
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(220, 53, 69, 0.3);
  color: white;
  text-decoration: none;
}

.social-icon i {
  font-size: 16px;
}

/* Map Section */
.contact-map {
  padding: 0;
  background: #f8f9fa;
}

.map-container {
  width: 100%;
  height: 400px;
  border-radius: 0;
  overflow: hidden;
}

.map-container iframe {
  width: 100%;
  height: 100%;
  border: none;
}

/* Responsive Design */
@media (max-width: 991px) {
  .contact-info-wrapper {
    position: static;
    margin-top: 30px;
  }
}

@media (max-width: 768px) {
  .contact-intro {
    padding: 80px 0 50px;
  }
  
  .contact-main-title h2 {
    font-size: 36px;
  }
  
  .contact-form-info {
    padding: 60px 0;
  }
  
  .contact-form-wrapper,
  .contact-info-wrapper {
    padding: 30px 20px;
  }
  
  .contact-form-header h3 {
    font-size: 24px;
  }
  
  .contact-info-item {
    padding: 15px;
  }
  
  .info-icon {
    width: 40px;
    height: 40px;
  }
  
  .info-icon i {
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .contact-main-title h2 {
    font-size: 28px;
  }
  
  .contact-description p {
    font-size: 16px;
  }
  
  .contact-form-wrapper,
  .contact-info-wrapper {
    padding: 20px 15px;
  }
  
  .social-icons {
    justify-content: center;
  }
}
</style>
